import { createContext, useContext } from 'react';

/**
 * Chat id made available to deeply nested renderers (MarkdownBlock images)
 * so they can resolve sandbox file paths (/home/user/…) into presigned URLs
 * via /api/sandbox/files/download. Undefined outside an authenticated chat
 * (share page, audio chat) — sandbox paths render as a placeholder there.
 */
export const SandboxChatIdContext = createContext<string | undefined>(
  undefined,
);

export function useSandboxChatId(): string | undefined {
  return useContext(SandboxChatIdContext);
}

/**
 * Resolves a sandbox path to a viewable URL where there is no chat to resolve
 * it through (the employee Computer tab). Wins over the chat id when set.
 * Resolves to null when the file can't be shown.
 */
export const SandboxFileUrlContext = createContext<
  ((path: string) => Promise<string | null>) | undefined
>(undefined);

export function useSandboxFileUrl():
  | ((path: string) => Promise<string | null>)
  | undefined {
  return useContext(SandboxFileUrlContext);
}
